import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Pricing.css';
import SubHero from '../../components/SubHero/SubHero';
import HeroImage from '../../images/hero1.jpg';
import Tag from '../../components/Tag/Tag';
import { FaCheck, FaStar, FaUsers, FaRocket } from "react-icons/fa";
import { MdBusiness, MdTrendingUp } from "react-icons/md";
import PricingPlans from '../../components/PricingPlans/PricingPlans';
import AdPackages from '../../components/AdPackages/AdPackages';

const PricingPage = () => {
  const [activeSection, setActiveSection] = useState('ads');

  useEffect(() => {
    window.scrollTo(0, 0);

    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);


  const handleSectionChange = (section) => {
    setActiveSection(section);
  };


  return (
    <div className="PricingPage">
      {/* Hero Section */}
      <SubHero 
        title="Pricing & Packages"
        subtitle="Choose the perfect plan to grow your business"
        image={HeroImage}
      />

      <div className="BODY">
        {/* Section Toggle */}
        <div className="pricing-toggle-section">
          <div className="pricing-container">
            <div className="section-toggle" data-aos="fade-up">
              <button 
                className={`toggle-btn ${activeSection === 'pricing' ? 'active' : ''}`}
                onClick={() => handleSectionChange('pricing')}
              >
                Pricing Plans
              </button>
              <button 
                className={`toggle-btn ${activeSection === 'ads' ? 'active' : ''}`}
                onClick={() => handleSectionChange('ads')}
              >
                Ad Packages
              </button>
            </div>
          </div>
        </div>


        <div className='pricing-container'>
          { activeSection === 'pricing' &&  <PricingPlans /> }
          { activeSection === 'ads' && <AdPackages /> }
        </div>
      </div>
    </div>
  );
};

export default PricingPage;